import * as React from 'react';
import { registerRemotes, loadRemote } from '@module-federation/runtime';
import LoadingSpinner from './components/LoadingSpinner';
import { resolveRemoteEntryUrl } from './config';

// Federation host bootstrap + shared deps are declared in vite.config.ts via
// the @module-federation/vite plugin. Here we only register this remote and
// lazy-load its exposed module. The manifest URL comes from the environment
// config (customAppRemotes override or the per-tenant customAppBaseDomain),
// same as every other MFE — never hardcoded to a specific deployment.
const OUTBOUND_REMOTE_NAME = 'encore-outbound';

registerRemotes([
  {
    name: OUTBOUND_REMOTE_NAME,
    entry: resolveRemoteEntryUrl(OUTBOUND_REMOTE_NAME),
  },
]);

// Module scope: recreating React.lazy inside the component body would remount
// the remote (and drop its state) on every host re-render.
const OutboundMfe = React.lazy(async () => {
  try {
    const value: any = await loadRemote<{ default: React.ComponentType }>(
      'encore-outbound/App'
    );
    return { default: value.default };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in loadRemote call:', error);
    throw error;
  }
});

export const OutboundContainer = () => {
  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <OutboundMfe />
    </React.Suspense>
  );
};
